/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_SearchingInputs */

const vi_reconcile_order_searching = /** @type {(inputs: Reconcile_Order_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tìm...`)
};

/**

* @param {Reconcile_Order_SearchingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_searching = /** @type {((inputs?: Reconcile_Order_SearchingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_SearchingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_searching(inputs)
});